import { useRole } from '@/hooks/useRole'
import { Link } from '@inertiajs/react'
import { Divider, NavLink, Stack, Text } from '@mantine/core'
import { IconSwitchHorizontal } from '@tabler/icons-react'
import { ComponentType } from 'react'

export type IconComponent = ComponentType<{ size?: number; stroke?: number }>

export type SidebarItem =
  | { type: 'link'; label: string; href: string; icon: IconComponent; active: boolean; visible?: boolean }
  | { type: 'divider'; visible?: boolean }
  | { type: 'section'; label: string; visible?: boolean }

const renderItem = (item: SidebarItem, index: number) => {
  if (item.type === 'divider') return <Divider key={`divider-${index}`} />
  if (item.type === 'section') {
    return (
      <Text
        key={`section-${index}-${item.label}`}
        size="xs"
        c="dimmed"
        fw={700}
        tt="uppercase"
        mt="sm"
        mb={4}
        px="sm"
      >
        {item.label}
      </Text>
    )
  }
  return (
    <NavLink
      key={item.href}
      component={Link}
      href={item.href}
      label={item.label}
      leftSection={<item.icon size={20} stroke={1.5} />}
      active={item.active}
    />
  )
}

export default function SidebarShell({ items }: { items: SidebarItem[] }) {
  const { isSuperAdmin } = useRole()

  const footerItems: SidebarItem[] = [
    {
      type: 'link',
      label: "Changer d'organisation",
      href: '/organizations',
      icon: IconSwitchHorizontal,
      active: false,
      visible: isSuperAdmin,
    },
  ]

  const visibleItems = items.filter((item) => item.visible !== false)
  const visibleFooterItems = footerItems.filter((item) => item.visible !== false)

  return (
    <div
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto',
      }}
    >
      <div style={{ flex: 1 }}>
        <Stack gap={4}>{visibleItems.map(renderItem)}</Stack>
      </div>

      <div>
        <Stack gap={4}>{visibleFooterItems.map(renderItem)}</Stack>
      </div>
    </div>
  )
}
